import React from 'react';
import urls from '../configs/urls'
import { Redirect} from 'react-router'
import '../css/App.css';
import '../css/Address.css';
import ls from 'local-storage';
import Loading from "./Loading";
import Retry from "./Retry";
import axios from "axios";
import TopNav from "./TopNav";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog/Dialog";
import Area from "../Modules/Area";
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import AppBody from "./AppBody";

class AddAddress extends React.Component{
    list =[];
    constructor(props){
        super(props);
        this.state = {
            redirect: false,
            retry: false,
            error: false,
            error_text: "",
            loading: false,
            areas: [],
            address: '',
            mahalat_id: -1,
            area_index: 0,
            extra_name: '',
            latitude: '',
            longitude: '',
        };
    }

    componentDidMount() {
        this.getArea();
    }

    render() {
        if(this.state.redirect)
            return (<Redirect push to={this.state.url}/>);
        if(this.state.retry)
            return (<Retry url={"/home"} type={"RELOAD"} text={"در اجرای درخواست مشکلی پیش آمده است. لطفا مجددا تلاش کنید."}/>);

        let extra = "";

        if(this.state.mahalat_id > 0 && this.state.areas[this.state.area_index]["extra"].length != 0)
            extra = (
                <Autocomplete
                    id="combo-box-demo"
                    options={this.state.areas[this.state.area_index]["extra"]}
                    getOptionLabel={(option) => option.name}
                    style={{ width: "80%",margin:"20px 10%",direction:"rtl",textAlign:"right" }}
                    renderInput={(params) => <TextField {...params} value={this.state.extra_name} onChange={this.setExtra} label="شماره قطعه" />}
                />);
        return (

            <AppBody loading={this.state.loading} showBotNav={false} name={"افزودن آدرس"} type={" bg-white"}>
                <form onSubmit={this.saveAddress}>
                    <select id={"addressArea"} size={1}
                            onChange={this.changeMahalat}>
                        {this.state.areas.map((area)=>{
                            return (
                                <option value={area.id}>{area.name}</option>
                            );
                        })}
                    </select>
                    {extra}
                    <input type={"text"} placeholder={"آدرس کامل"} id={"address_text"} value={this.state.address} onChange={this.setAddressText}/>
                    <input type={"submit"} className={"btn submitPhone"} value={"افزودن آدرس"}/>
                </form>

                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{this.state.dialogTitle}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {this.state.dialogText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            بستن
                        </Button>
                    </DialogActions>
                </Dialog>
            </AppBody>
        )
    }

    setExtra = (event)=>{
        this.setState({extra_name:event.target.value})
    };
    setAddressText = (event)=>{
        this.setState({address:event.target.value})
    };
    changeMahalat = (event)=>{
        event.target.size=0;
        this.setState({mahalat_id:event.target.value,area_index:event.target.selectedIndex});
    };
    getArea = () =>{
        axios.get(urls.baseUrl+urls.getArea+"?city_id="+ls.get("city_id"))
            .then(res => {
                if(res.data.code == 200){
                    let areasArray = [{id:-1,name:"انتخاب محله"}];
                    let areas = res.data.mahalat;
                    areas.forEach((area)=>{
                        areasArray.push(new Area(area.id,area.mahalat_name,area.extra));
                    });
                    this.setState({areas:areasArray});
                }
                else{
                    this.setState({
                        open:true,
                        dialogHasConfirm:false,
                        dialogTitle:"خطا.",
                        dialogText:res.data.message,
                        dialogType:"NONE",
                        loading:false,
                    });
                    return;
                }
            })
            .catch(error=>{
                console.log("Error : ",error);
                this.setState({
                    open:true,
                    dialogHasConfirm:false,
                    dialogTitle:"ثبت آدرس انجام نشد.",
                    dialogText:"متاسفانه ثبت آدرس انجام نشد. لطفا دوباره امتحان کنید.",
                    dialogType:"NONE",
                    loading:false,
                });
                return;
            })
    }
    handleClose  = () => {
        this.setState({open:false})
    };
    saveAddress = (event)=>{
        event.preventDefault();
        if(this.state.address.length <= 2)
        {
            this.setState({
                open:true,
                dialogHasConfirm:false,
                dialogTitle:"آدرس لازمه !",
                dialogText:"لطفا ابتدا یک آدرس انتخاب کنید.",
                dialogType:"NONE",
                loading:false,
            });
            return;
        }

        let data = {
            extra_name:this.state.extra_name,
            mahalat_id:this.state.mahalat_id,
            latitude:this.state.latitude,
            longitude:this.state.longitude,
            address:this.state.address,
            city_id:ls.get("city_id"),
            token:ls.get("token"),
        };
        axios.post(urls.baseUrl+urls.addAddress,data)
            .then(res => {
                if(res.data.code == 200){
                    this.props.history.push("/address");
                }
                else{
                    this.setState({
                        open:true,
                        dialogHasConfirm:false,
                        dialogTitle:"ثبت آدرس انجام نشد.",
                        dialogText:res.data.message,
                        dialogType:"NONE",
                        loading:false,
                    });
                    return;
                }
            })
            .catch(error=>{
                this.setState({
                    open:true,
                    dialogHasConfirm:false,
                    dialogTitle:"ثبت آدرس انجام نشد.",
                    dialogText:"متاسفانه ثبت آدرس انجام نشد. لطفا دوباره امتحان کنید.",
                    dialogType:"NONE",
                    loading:false,
                });
                return;
            })

    }

}



export default AddAddress;
